"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('save', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("g", {
    stroke: "none",
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: props.strokeLinejoin
  }, _react.default.createElement("g", {
    transform: "translate(6.000000, 5.000000)",
    strokeWidth: props.strokeWidth
  }, _react.default.createElement("g", null, _react.default.createElement("path", {
    d: "M3,1 L28.2814135,1 L36,8.20646467 L36,34 C36,35.6568542 34.6568542,37 33,37 L3,37 C1.34314575,37 2.02906125e-16,35.6568542 0,34 L0,4 C2.41183085e-16,2.34314575 1.34314575,1 3,1 Z",
    stroke: props.outStrokeColor,
    fill: props.outFillColor,
    fillRule: "nonzero"
  }), _react.default.createElement("path", {
    d: "M18.0083333,1 L18,8.38461538 C18,8.72448292 17.5522847,9 17,9 L9,9 C8.44771525,9 8,8.72448292 8,8.38461538 L8,1",
    stroke: props.innerStrokeColor
  }), _react.default.createElement("path", {
    d: "M3,1 L28.2814135,1",
    stroke: props.outStrokeColor,
    strokeLinecap: props.strokeLinecap
  }), _react.default.createElement("path", {
    d: "M8,21 L28,21",
    stroke: props.innerStrokeColor,
    strokeLinecap: props.strokeLinecap
  }), _react.default.createElement("path", {
    d: "M8,29 L18.0083333,29",
    stroke: props.innerStrokeColor,
    strokeLinecap: props.strokeLinecap
  })))));
});

exports.default = _default;